export const HEADER_LOGGING_EMPLOYEE_NUMBER = 'Z-EMPLOYEE-NUMBER';
export const HEADER_LOGGING_LOG_ROCKET_URL = 'Z-LOGROCKET';
export const HEADER_LOGGING_APPLICATION_NAME = 'Z-APPLICATION';
export const HEADER_APP_VERSION = 'X-APP-VERSION';
